import {transparentize} from "polished";
import {css} from 'styled-components';

/* Theme Colours */

const acurisBrandColours = {
    black: "#232121",
    warmGreyXI: "#373533",
    warmGreyX: "#4A4844",
    warmGreyIX: "#5D5955",
    warmGreyVIII: "#706C67",
    warmGreyVII: "#96908A",
    warmGreyVI: "#BBB4AC",
    warmGreyV: "#D6D0C8",
    warmGreyIV: "#E1DBD5",
    warmGreyIII: "#EAE5E1",
    warmGreyII: "#F0ECE9",
    warmGreyI: "#F5F2F0",
    coolGreyI: "#F7F7F7",
    redLight: "#D84A57",
    equitiesGreenMedium: "#77AF5A",
    equitiesGreenDark: "#458535",
    equitiesGreenDarker: "#3B7433",
    fixedIncomeIndigoMedium: "#004FC4"
};

const offBrandColours = {
    yellow: "#DEB300",
    orange: "#F58823"
};

/* Semantic Colours */

export const baseFontFamily = "Lato, sans-serif";
export const baseLineHeight = 1.5;
export const baseFontSize = 14;

export const positiveColour = acurisBrandColours.equitiesGreenDarker;
export const negativeColour = acurisBrandColours.redLight;
export const alertColour = acurisBrandColours.redLight;
export const warningColour = offBrandColours.orange;
export const notificationColour = offBrandColours.yellow;
export const authorBackgroundColour = "#f5f2f0";
export const headerBackgroundColour = acurisBrandColours.warmGreyII;
export const coolBackgroundColour = acurisBrandColours.coolGreyI;
export const subHeaderBackgroundColour = acurisBrandColours.warmGreyI;
export const primaryRankingBackgroundColour = acurisBrandColours.warmGreyI;
export const viewAndSubdivideButtonColour = acurisBrandColours.warmGreyV;
export const primaryRankingTagColour = acurisBrandColours.equitiesGreenDark;
export const primaryRankingTagTextColour = acurisBrandColours.warmGreyI;
export const pageHeaderBackgroundColour = "transparent";
export const tableBorderColour = acurisBrandColours.warmGreyIII;
export const acurisButtonBackgroundColour = acurisBrandColours.warmGreyX;

export const primaryTextColour = acurisBrandColours.black;
export const subduedTextColour = acurisBrandColours.warmGreyVIII;
export const extraSubduedTextColour = acurisBrandColours.warmGreyVI;
export const subduedInvertedTextColour = acurisBrandColours.warmGreyV;
export const inputPlaceholderText = acurisBrandColours.warmGreyVII;
export const pageBackgroundColour = "white";
export const borderColour = acurisBrandColours.warmGreyV;
export const shadedBackgroundColour = acurisBrandColours.warmGreyI;
export const almostInvisibleShadedBackgroundColour = transparentize(0.5, acurisBrandColours.warmGreyI);
export const triggerColour = acurisBrandColours.equitiesGreenDarker;
export const highlightColour = acurisBrandColours.equitiesGreenMedium;
export const secondaryHighlightColour = acurisBrandColours.warmGreyIX;
export const kpiBackgroundColour = transparentize(0.9, acurisBrandColours.equitiesGreenMedium);
export const kpiIconBackgroundColour = acurisBrandColours.equitiesGreenDark;
export const portfolioIconBackgroundColour = acurisBrandColours.warmGreyXI;
export const headingColour = acurisBrandColours.warmGreyXI;

export const primaryButtonShadowColour = transparentize(0.75,acurisBrandColours.equitiesGreenDarker);
export const secondaryButtonShadowColour = transparentize(0.75,acurisBrandColours.warmGreyXI);

export const neutralTertiaryButtonTextColour = acurisBrandColours.warmGreyIX;
export const neutralTertiaryButtonBackgroundColour = "transparent";
export const neutralTertiaryButtonBorderColour = acurisBrandColours.warmGreyIV;
export const neutralTertiaryButtonHoverBackgroundColour = "white";

export const tabCurrentTopBorderColour = acurisBrandColours.equitiesGreenDark;
export const tabBackgroundColour = acurisBrandColours.warmGreyI;
export const tabCurrentBackgroundColour = "white";
export const tabHoverBackgroundColour = acurisBrandColours.equitiesGreenDark;
export const tabActiveBackgroundColour = acurisBrandColours.equitiesGreenDarker;

export const contentToggleBackgroundColour = acurisBrandColours.warmGreyI;
export const contentToggleBorderColour = acurisBrandColours.warmGreyIV;
export const contentToggleCurrentBackgroundColour = acurisBrandColours.equitiesGreenDark;
export const contentToggleHoverBackgroundColour = acurisBrandColours.warmGreyIII;
export const contentToggleLineColour = acurisBrandColours.warmGreyIV;

export const menuActiveBackgroundColour = acurisBrandColours.equitiesGreenDarker;
export const menuTextColor = acurisBrandColours.equitiesGreenDarker;

export const timelineColour = acurisBrandColours.warmGreyII;

export const darkBoxShadowColour = acurisBrandColours.warmGreyV;
export const boxShadowColour = acurisBrandColours.warmGreyII;
export const boxBorderColour = acurisBrandColours.warmGreyII;
export const widgetBorderColour = acurisBrandColours.warmGreyIV;

export const longColour = "#4393b2";
export const shortColour = "#d38b44";
export const sentimentColours = {
    1: shortColour,
    2: "#F48824",
    3: "#CE9665",
    4: "#B1A094",
    5: subduedTextColour,
    6: subduedTextColour,
    7: "#9AA5B4",
    8: "#779CC8",
    9: "#5092DE",
    10: longColour
};

export const ellipsis = {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
};

export const ellipsisStyle = css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
